import axios from "axios";
import keycloak from "./Keycloak";
process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
const instance = axios.create({
    apiBaseURL: process.env.REACT_APP_API_BASE_URL,
    apiURL: process.env.REACT_APP_API_URL,
    baseURL: process.env.REACT_APP_API_URL,
    frontURL : process.env.REACT_APP_KEYCLOAK_REDIRECT_URI
});

const token = localStorage.getItem('token');

const secured = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    apiURL: process.env.REACT_APP_API_URL,
    apiBaseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Authorization': `Bearer ${token}`
    }
});

const nextcloud = axios.create({
    baseURL: process.env.REACT_APP_NEXTCLOUD_BASE_URL,
    apiURL: process.env.REACT_APP_NEXTCLOUD_BASE_URL,
    apiBaseURL: process.env.REACT_APP_NEXTCLOUD_BASE_URL
});

const marketplace = axios.create({
    baseURL: process.env.REACT_APP_MARKETPLACE_API_BASE_URL,
    auth: {
        username: process.env.REACT_APP_MARKETPLACE_API_KEY,
        password: ''
    },
    cors: false
});

nextcloud.interceptors.response.use( res => res, error => {
    console.log(token);
    if (error.response) {
        if (error.response.status === 401) {
            localStorage.removeItem('token');
            keycloak.logout({redirectUri:process.env.REACT_APP_KEYCLOAK_REDIRECT_URI});
        }
        return error.response;
    }

})


secured.interceptors.response.use( res => res, error => {
    if (error.response) {
        if (error.response.status === 401) {
            localStorage.removeItem('token');
            keycloak.logout({redirectUri:process.env.REACT_APP_KEYCLOAK_REDIRECT_URI});
        }
        return error.response;
    }
})

secured.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instance;

export { secured, nextcloud, marketplace };

